import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { reviewActions } from "../../../store/review-slice";
import { markNormalizationShown } from "../../../utils/reviewStorageUtils";
import "./NormalizationMessage.css";

// One-time floating card shown after onboarding completes (Figma image 1).
// Visually centered over the page with a soft backdrop so it reads as a modal,
// but the backdrop has pointer-events: none so the user can still click through
// to the page behind. Persistence flag is written on mount so the card never
// reappears even if the user navigates away before dismissing it explicitly.

const NormalizationMessage = () => {
  const dispatch = useDispatch();
  const normalizationVisible = useSelector(
    (state) => state.review.normalizationVisible
  );

  useEffect(() => {
    if (normalizationVisible) {
      markNormalizationShown();
    }
  }, [normalizationVisible]);

  if (!normalizationVisible) return null;

  const handleDismiss = () => {
    dispatch(reviewActions.hideNormalization());
  };

  return (
    <div className="normalizationBackdrop" aria-hidden="true">
      <div
        className="normalizationCard"
        role="status"
        aria-live="polite"
        aria-label="You are all set now"
      >
        <div className="normalizationCardHeader">
          <h3 className="normalizationCardTitle">You are all set now 🎊</h3>
          <button
            type="button"
            className="normalizationCardCloseBtn"
            onClick={handleDismiss}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
        <div className="normalizationCardBody">
          <p className="normalizationCardText">
            We'll monitor how IFH performs for your store and check in for feedback
            once you start seeing value.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NormalizationMessage;
